export const QUOTE_LIST_SLOTS = {
    AFTER_LIST_TABS: 'dokan-quote-list-after-tabs',
    BEFORE_LIST_TABLE: 'dokan-quote-list-before-table',
    AFTER_LIST_TABLE: 'dokan-quote-list-after-table',
    BEFORE_STATUS_TABS: 'dokan-status-tabs-before',
    AFTER_STATUS_TABS: 'dokan-status-tabs-after',
    BEFORE_BULK_ACTION: 'dokan-quote-list-before-bulk-action',
    AFTER_BULK_ACTION: 'dokan-quote-list-after-bulk-action',
    BEFORE_LIST_SEARCH: 'dokan-quote-list-before-search',
    AFTER_LIST_SEARCH: 'dokan-quote-list-after-search',
    BEFORE_LIST_EMPTY: 'dokan-quote-list-before-empty-template',
    AFTER_LIST_EMPTY: 'dokan-quote-list-after-empty-template',
} as const;
